/**
 *Created by jmmartinez on 26/09/18
 *
 * v.1.1 22/09/2021 creada constante PREFIJO.
 *                  Prefijado el tiempo de caducidad cuando no se pasa parámetro.
 **/

import {getFormattedDateTimeNow, getMinutosHastaAhora} from './DateUtils'

const PREFIJO= 'MATRIMUR';

export const crearSession= (authData) => {
    //console.log("CREAR SESSION");
    //console.log(authData);

    if (authData) {
        localStorage.setItem(PREFIJO + '_usuarioCodigo', authData.usuarioCodigo);
        localStorage.setItem(PREFIJO + '_token', authData.token);
        localStorage.setItem(PREFIJO + '_date', getFormattedDateTimeNow());
    }
}

export const getSession= (sessionCaducidadMinutos) => {
    let sessionCaducidadMinutosReal= sessionCaducidadMinutos ? sessionCaducidadMinutos : 10;
    //console.log("GET SESSION");

    let usuarioCodigo= localStorage.getItem(PREFIJO + '_usuarioCodigo');
    //console.log("USUARIOCODIGO: ", usuarioCodigo);
    if (usuarioCodigo){
        let token= localStorage.getItem(PREFIJO + '_token');
        //console.log("TOKEN: ", token);
        let date= localStorage.getItem(PREFIJO + '_date');
        //console.log("DATE: ", date);
        let difMinutos=  getMinutosHastaAhora(date);
        //console.log(difMinutos);
        if (difMinutos > sessionCaducidadMinutosReal){
            //console.log("SESION CADUCADA");
            cerrarSession();
            return null;
        }
        else{
            return {
                usuarioCodigo: usuarioCodigo,
                token: token,
            };
        }
    }
    else {
        return null;
    }
}

export const cerrarSession= () => {
    //console.log("CERRAR SESSION");
    localStorage.removeItem(PREFIJO + "_usuarioCodigo");
    localStorage.removeItem(PREFIJO + "_token");
    localStorage.removeItem(PREFIJO + "_date");
}

export const refreshSession= (sessionCaducidadMinutos) => {
    let sessionCaducidadMinutosReal= sessionCaducidadMinutos ? sessionCaducidadMinutos : 10;
    let usuarioCodigo= localStorage.getItem(PREFIJO + '_usuarioCodigo');
    //console.log("USUARIOCODIGO: ", usuarioCodigo);
    if (usuarioCodigo){
        let date= localStorage.getItem(PREFIJO + '_date');
        //console.log("DATE: ", date);
        let difMinutos=  getMinutosHastaAhora(date);
        //console.log(difMinutos);
        if (difMinutos <= sessionCaducidadMinutosReal){
            localStorage.setItem(PREFIJO + '_date', getFormattedDateTimeNow());
        }
        else{
            //console.log("Refresh Sesion caducada");
            cerrarSession();
        }
    }
}

/*
export const sessionCaducada= () {
    let usuarioCodigo= localStorage.getItem('EJ2SHOP_usuarioCodigo');
    if (usuarioCodigo){
        let date= localStorage.getItem('EJ2SHOP_date');
        let difMinutos=  getMinutosHastaAhora(date);
        if (difMinutos > sessionCaducidadMinutos){
            localStorage.setItem('EJ2SHOP_date', getFormattedDateTimeNow());
        }
        else{
            cerrarSession();
        }
    }
}
*/